import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import type { UserRole } from '@kerbly/shared';
import { useAuth } from '../lib/auth';
import { Spinner } from './Spinner';

interface ProtectedRouteProps {
  role?: UserRole;
  children: ReactNode;
}

export function ProtectedRoute({ role, children }: ProtectedRouteProps) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner size="lg" label="Loading…" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (role && user.role !== role) {
    const fallback =
      user.role === 'admin' ? '/admin' : user.role === 'operator' ? '/dashboard' : '/';
    return <Navigate to={fallback} replace />;
  }

  return <>{children}</>;
}
